import React from 'react';
import { mainGuide } from '../data/resources';
import { guideInteriorPages } from '../data/pendingContent';
const topics = [{
  title: 'Materiali e strumenti',
  text: 'Conoscere filati, tricotin e strumenti utili, e capire a cosa serve ciascuno.'
}, {
  title: 'La tecnica di base',
  text: 'Prendere confidenza con il tricotin e con i primi passaggi della lavorazione.'
}, {
  title: 'Preparare il cordoncino',
  text: 'Preparare il cordoncino, anche con il filo metallico quando il progetto lo richiede.'
}, {
  title: 'Modellare le forme',
  text: 'Usare il cartamodello come riferimento per dare forma a lettere, cuori e piccoli motivi.'
}, {
  title: 'Le rifiniture',
  text: 'Curare le estremità e i dettagli per presentare al meglio la tua creazione.'
}];
export function MainGuide() {
  return <section aria-labelledby="guide-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-132" data-mp="c6bqelo6lz5l">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-133" data-mp="h66fcjoeceo0">
        <div className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-134" data-mp="3q0ept7dt5vxt">
          <div className="rounded-[2rem] bg-blush overflow-hidden aspect-square shadow-soft" data-id="element-135" data-mp="3q2rdm168z0is">
            <img src={mainGuide.image} alt={mainGuide.imageAlt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-136" data-mp="3lytg1uwklxru" />
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-137" data-mp="3v0sxupfet5vu">
          <p className="text-sm font-semibold text-berry-deep" data-id="element-138" data-mp="3uxohyusl0lpc">La guida principale</p>
          <h2 id="guide-title" className="mt-2 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-139" data-mp="37aggkny9xwsl">
            {mainGuide.name}
          </h2>
          <p className="mt-3 font-serif italic text-lg sm:text-xl text-ink" data-id="element-140" data-mp="3h11mkwga23lj">{mainGuide.benefit}</p>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/80 max-w-xl" data-id="element-141" data-mp="3c88hu8kt6v9g">
            {mainGuide.description}
          </p>

          <ol className="mt-10 border-t border-ink/10" data-id="element-142" data-mp="2ohmakjimpf0i">
            {topics.map((t, i) => <li key={t.title} className="grid grid-cols-[2.5rem_1fr] gap-x-3 py-5 border-b border-ink/10" data-id="element-143" data-mp="2jk2wpkpuf493" data-mpi={i}>
                <span className="font-serif text-xl font-semibold text-berry-deep leading-snug" data-id="element-144" data-mp="nh7nh6hjdqu7">
                  {i + 1}
                </span>
                <div data-id="element-145" data-mp="x6r5yb1c7ioj">
                  <h3 className="font-serif text-lg sm:text-xl font-semibold text-plum" data-id="element-146" data-mp="x8c2g677pbp1">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-base leading-relaxed text-ink/75" data-id="element-147" data-mp="11az04nqkdqu5">{t.text}</p>
                </div>
              </li>)}
          </ol>

          {guideInteriorPages.length > 0 && <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-148" data-mp="9i87soc04ma6">
              {guideInteriorPages.map(page => <div key={page.src} className="aspect-[3/4] rounded-xl overflow-hidden bg-blush shadow-soft" data-id="element-149" data-mp="dhyuafuhwg8w">
                  <img src={page.src} alt={page.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-150" data-mp="iga6gx89j2ua" />
                </div>)}
            </div>}
        </div>
      </div>
    </section>;
}